import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/proveedor",
    component: MasterLayout,
    children: [
      {
        path: "lentes",
        name: "proveedor.lente",
        component: () => import("@/views/proveedor/lentes/index.vue")
      },
      {
        path: "monturas",
        name: "proveedor.montura",
        component: () => import("@/views/proveedor/monturas/index.vue")
      },
    ]
  }
]